<template>
  <div id="login" class="login-container">
    <div class="login-card">
      <!-- <img :src="logo" class="logo"/> -->
      <!-- <svg
          id="icon-M" viewBox="0 0 1024 1024"
          width="90px">
          <path d="M672.9 102.4c-82.7 0-156.5 110.2-204.8 282.6C419.8 212.6 346 102.4 263.3 102.4 117.9 102.4 0 469.2 0 921.6h117C117 501.5 182.5 161 263.3 161c80.8 0 146.3 314.4 146.3 702.1h117c0-387.8 65.5-702.1 146.3-702.1 80.8 0 146.3 340.6 146.3 760.6h117c0-452.4-117.9-819.2-263.3-819.2zM994.8 863.1c-15.9 0-29.3 12.6-29.3 29.1 0 16.8 13.4 29.4 29.3 29.4s29.2-12.6 29.2-29.4c0-16.5-13.3-29.1-29.2-29.1z m0 54.2c-13.6 0-24-10.8-24-25.1 0-14 10.4-24.8 24-24.8 13.4 0 23.9 10.8 23.9 24.8 0 14.3-10.4 25.1-23.9 25.1z" fill="#FFBC0D"></path><path d="M1008.5 885c0-6.6-3.8-9.8-11.9-9.8h-13.2v34.2h5.3v-14.7h5.6l9.2 14.7h5.7l-9.7-15.1c5.1-0.5 9-3.1 9-9.3z m-14.2 5.4h-5.5v-10.9h7c3.6 0 7.5 0.7 7.5 5.2-0.1 5.5-4.3 5.7-9 5.7z" fill="#FFBC0D">
          </path>
      </svg> -->
      <div class="login-logo"></div>
      <div style="width: 100%">
        <a-form id="components-form-demo-normal-login" :form="form" class="login-form" @submit="handleSubmit">
          <a-form-item>
            <a-input :size="$globalSize" v-decorator="[
              'userName',
              {
                rules: [
                  {
                    required: true,
                    message: this.$t('message.loginPage.usernameTip'),
                  },
                ],
              },
            ]" placeholder="Email">
              <a-icon slot="prefix" type="user" style="color: rgba(0, 0, 0, 0.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input :size="$globalSize" v-decorator="[
              'password',
              {
                rules: [
                  {
                    required: true,
                    message: this.$t('message.loginPage.passwordCharacters'),
                  },
                  { validator: checkPwd },
                ],
              },
            ]" type="password" placeholder="Password">
              <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, 0.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button :size="$globalSize" shape="round" html-type="submit" class="login-form-button" :loading="loading">
              {{ $t("message.loginPage.loginBtn") }}
            </a-button>
            <a-divider class="f-l"></a-divider>
            <a-button shape="round" class="login-form-button ms-button" type="default" @click="loginWithMicrosoft">
              <img src="https://img.icons8.com/color/48/000000/microsoft.png" style="width: 35px"
                alt="Microsoft" />Login with Microsoft
            </a-button>
            <!-- <a-button
              shape="round"
              class="login-form-button"
              @click="logoutWithMicrosoft"
            >
              <img
                src="https://img.icons8.com/color/48/000000/microsoft.png"
                style="width: 35px"
                alt="Microsoft"
              />Logout with Microsoft
            </a-button> -->
          </a-form-item>
        </a-form>
      </div>
    </div>
    <a-modal v-model="visible" title="注册" @ok="handleOk" width="700px" :footer="null">
      <a-row>
        <a-col :span="18">
          <a-form :form="form2" @submit="register">
            <a-form-item v-bind="formItemLayout" label="用户名">
              <a-input :size="$globalSize" v-decorator="[
                'userName',
                {
                  rules: [
                    {
                      required: true,
                      message: '账号不能为空',
                    },
                  ],
                },
              ]" />
            </a-form-item>
            <a-form-item v-bind="formItemLayout" label="密码" has-feedback>
              <a-input :size="$globalSize" v-decorator="[
                'password',
                {
                  rules: [
                    {
                      required: true,
                      message: this.$t(
                        'message.loginPage.passwordCharacters'
                      ),
                    },
                    {
                      validator: checkPwd,
                    },
                  ],
                },
              ]" type="password" />
            </a-form-item>
            <a-form-item v-bind="formItemLayout" label="邮箱">
              <a-input :size="$globalSize" v-decorator="[
                'email',
                {
                  rules: [
                    {
                      type: 'email',
                      message: '请输入正确的邮箱格式',
                    },
                    {
                      required: true,
                      message: '邮箱不能为空',
                    },
                  ],
                },
              ]" />
            </a-form-item>
            <a-form-item v-bind="tailFormItemLayout">
              <a-button :size="$globalSize" type="primary" html-type="submit">
                Register
              </a-button>
            </a-form-item>
          </a-form>
        </a-col>
        <a-col :span="0"> </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import loginService from "@/interface/pages/Login/login";
import { mapMutations } from "vuex";
import { styleChange } from "@/utils/styleChange";
// import logoImg from '@/assets/home-logo.png'
import Utils from "@/utils";

export default {
  data() {
    return {
      loading: false,
      // logo:logoImg,
      visible: false,
      confirmDirty: false,
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 16,
            offset: 8,
          },
        },
      },
    };
  },
  created() {
    console.log(this.$route.query);
    if (this.$route.query.from === "ms") {
      const newQuery = { ...this.$route.query };
      delete newQuery.from;

      this.$router.replace({
        ...this.$route,
        query: newQuery,
      });
      // this.loginWithMicrosoft();
      if (localStorage.getItem("token")) {
        this.loginCheck();
      } else {
        this.loginWithMicrosoft();
      }
    }
    this.msalInstance.handleRedirectCallback(async (error, response) => {
      if (error) {
        console.error("Redirect error:", error);
        return;
      }
      console.log("Redirect response:", response);
      if (
        response &&
        response.idToken &&
        response.idToken.rawIdToken &&
        !localStorage.getItem("isLogout")
      ) {
        localStorage.setItem("idToken", response.idToken.rawIdToken);
        this.$router.push("/login_redirect");
      } else {
        localStorage.removeItem("isLogout");
      }
    });
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
    this.form2 = this.$form.createForm(this, { name: "register" });
  },
  methods: {
    ...mapMutations(["exchangeStyle"]),
    async loginCheck() {
      try {
        const _self = this;
        const { data: res } = await loginService.isLoginAnother(this, { params: { token: localStorage.getItem("token") } });
        if (res.code == "200") {
          if (res.data) {
            localStorage.setItem("userEmail", res.data.email);
            this.$confirm({
              title: this.$t("message.loginPage.chooseAnotherAccount"),
              okText: this.$t("message.commonUsage.yes"),
              cancelText: this.$t("message.commonUsage.no"),
              onOk() {
                _self.loginWithMicrosoft();
              },
              onCancel() {
                _self.$router.push("/audience/userGroupList");
              },
            });
          } else {
            this.loginWithMicrosoft();
          }
        } else {
          this.loginWithMicrosoft();
        }
      } catch (err) {
        console.log(err);
        this.loginWithMicrosoft();
      }
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    initInfo(data) {
      localStorage.setItem("userName", data.user_name);
      localStorage.setItem("userId", data.user_id);
      localStorage.setItem("token", data.token);
      localStorage.setItem("time_zone", data.time_zone);
      localStorage.setItem("subscriptionName", data.subscription_name);
      localStorage.setItem("subscriptionID", data.subscription_id);
      localStorage.setItem("userType", data.type); // Microsoft or Atom
      localStorage.setItem("email", data.email); 
      loginService
        .getUserMenu(this, {
          params: {
            userId: data.user_id,
          },
        })
        .then((menuRes) => {
          const menu = menuRes.data;
          localStorage.setItem("menu", JSON.stringify(menu.data));
          this.$store.dispatch('fetchButtonPermission')
          if (menu.data && menu.data.length) {
            this.$router.push("/audience/userGroupList");
          } else {
            this.$router.push("/unSubscription");
          }
          this.$message.success("login success!", 1);
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;
          // console.log('Received values of form: ', values);
          // var url = "/api/userManagement/bdsLogin";
          var param = {
            userName: values.userName,
            password: Utils.encrypt(values.password),
          };

          loginService
            .login(this, { params: param })
            .then(
              function (resp) {
                var res = resp.data;
                if (res.code == "200") {
                  this.initInfo(res.data);
                } else {
                  this.$message.error(res.message, 3);
                }
              }.bind(this)
            )
            .catch((reason) => {
              console.log(reason);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          console.log(values);
        }
      });
    },
    checkPwd(rule, value, callback) {
      if (!value) {
        callback("");
        return;
      }

      if (value.length < 8) {
        callback(this.$t("message.loginPage.passwordCharacters"));
      } else {
        // var password = value.toUpperCase();
        // var newpassword = value;
        // // 数字,特殊字符,大小写字母的匹配
        // var boolean_num = false;
        // var boolean_A = false;
        // var boolean_a = false;
        // var boolean_specialchar = false;
        // for (var i = 0; i < newpassword.length; i++) {
        //   if (boolean_A == true && boolean_a == true && boolean_num == true
        //       && boolean_specialchar == true)
        //     break;
        //   if (newpassword[i].charCodeAt() >= 65
        //       && newpassword[i].charCodeAt() <= 90) {
        //     boolean_A = true;
        //     continue;
        //   }
        //   if (newpassword[i].charCodeAt() >= 48
        //       && newpassword[i].charCodeAt() <= 57) {
        //     boolean_num = true;
        //     continue;
        //   }
        //   if (newpassword[i].charCodeAt() >= 97
        //       && newpassword[i].charCodeAt() < 122) {
        //     boolean_a = true;
        //     continue;
        //   }
        //   if ((newpassword[i].charCodeAt() >= 33 && newpassword[i].charCodeAt() <= 47)
        //       || (newpassword[i].charCodeAt() >= 58 && newpassword[i]
        //           .charCodeAt() <= 64)
        //       || (newpassword[i].charCodeAt() >= 91
        //           && newpassword[i].charCodeAt() && newpassword[i]
        //               .charCodeAt() <= 96)
        //       || (newpassword[i].charCodeAt() >= 123 && newpassword[i]
        //           .charCodeAt() <= 127)) {
        //     boolean_specialchar = true;
        //     continue;
        //   }
        // }
        // if (boolean_A == false || boolean_a == false || boolean_num == false
        //     || boolean_specialchar == false) {
        //   callback(this.$t('message.loginPage.passwordFormat'));
        // } else {
        //   callback();
        // }
        callback();
      }
    },
    register(e) {
      e.preventDefault();
      this.form2.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          var url = "/api/userManagement/register";
          var param = {
            user_name: values.userName,
            password: values.password,
            email: values.email,
          };
          this.$ajax
            .post(url, param)
            .then((resp) => {
              var res = resp.data;
              if (res.code == "200") {
                this.$message.success("注册成功", 1);
              } else {
                this.$message.error("注册失败", 3);
              }
              this.visible = false;
            })
            .catch((reason) => {
              this.$message.error("注册失败", 1);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-card {
  width: 500px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 20px 60px 40px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-top: 5%;
  border-radius: 4px;
}

.login-logo {
  margin-top: 20px;
  margin-bottom: 10px;
  width: 108px;
  height: 72px;
  background: url("../../assets/atom-logo.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>
<style scoped>
#components-form-demo-normal-login .login-form {
  max-width: 300px;
}

#components-form-demo-normal-login .login-form-forgot {
  float: right;
}

#components-form-demo-normal-login .login-form-button {
  width: 100%;
  height: 40px;
  line-height: 40px;
  color: #fff;
  background-color: #d46910;
}

#components-form-demo-normal-login .ms-button {
  border-color: #d46910;
  color: #d46910;
  background-color: #fff;
}
</style>
